export async function openSupportChat(): Promise<void> {
  try {
    await loadForethoughtScripts()
    await loadSalesforceScripts()
    if (typeof window.Forethought !== 'undefined') {
      window.Forethought('widget', 'show')
      window.Forethought('widget', 'open')
    } else {
      console.error('Forethought widget is not initialized')
    }
  } catch (error) {
    console.error(error)
  }
}

function loadForethoughtScripts() {
  return new Promise<void>((resolve, reject) => {
    if (!document.getElementById('forethought-widget-embed-script')) {
      const forethoughtScript = document.createElement('script')
      forethoughtScript.src = 'https://solve-widget.forethought.ai/embed.js'
      forethoughtScript.id = 'forethought-widget-embed-script'
      forethoughtScript.type = 'application/javascript'
      forethoughtScript.dataset.apiKey = '5791f610-77c3-450b-9cef-3b6c3419962d'
      forethoughtScript.dataset.ftWorkflowTag = 'Freckle_Platform'
      forethoughtScript.dataset.ftUrl = 'https://classroom.freckle.com'
      forethoughtScript.onload = () => resolve()
      forethoughtScript.onerror = () => reject('Failed to load Forethought script')
      document.body.appendChild(forethoughtScript)
    } else {
      resolve() // Script already loaded
    }
  })
}

function loadSalesforceScripts() {
  return new Promise<void>((resolve, reject) => {
    if (!document.getElementById('salesforce-bootstrap-script')) {
      // Create and load the Salesforce bootstrap script
      const salesforceScript = document.createElement('script')
      salesforceScript.src =
        'https://renlearn.my.site.com/ESWRLIProductSupportCh1733220094443/assets/js/bootstrap.min.js'
      salesforceScript.id = 'salesforce-bootstrap-script'
      salesforceScript.type = 'text/javascript'
      salesforceScript.onload = () => {
        try {
          // Initialize Embedded Messaging after script loads
          window.embeddedservice_bootstrap.settings.language = 'en_US'
          window.addEventListener('onEmbeddedMessagingReady', () => {
            console.log('Embedded Messaging is ready')
          })
          window.embeddedservice_bootstrap.init(
            '00DHr000001sf9h',
            'RLI_Product_Support_Chat',
            'https://renlearn.my.site.com/ESWRLIProductSupportCh1733220094443',
            {
              scrt2URL: 'https://renlearn.my.salesforce-scrt.com'
            }
          )
          resolve()
        } catch (err) {
          console.error('Error initializing Embedded Messaging:', err)
          reject(err)
        }
      }
      salesforceScript.onerror = () => reject('Failed to load Salesforce script')
      document.body.appendChild(salesforceScript)
    } else {
      resolve() // Script already loaded
    }
  })
}
